import { jsx } from 'react/jsx-runtime';
import { useArcUI } from '../../hooks/useArcUI';

const ArcUI = ({
  position,
  children,
  ...divProps
}) => {
  const widgetRef = useArcUI(position);
  return (
    // Need to wrap the UI ref in a div because the View UI will
    // use the parent element to add and remove the UI element
    /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("div", { ref: widgetRef, ...divProps, children }) })
  );
};

export { ArcUI };
